import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
import "@arco-design/web-react/es/Typography/style";
import _Typography from "@arco-design/web-react/es/Typography";
import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import errorBoundary from '@/assets/error.svg';
import styled from '@emotion/styled';
const {
  Title
} = _Typography;
const ErrorWrapper = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: var(--color-bg-1);
  color: var(--color-text-3);
  gap: 20px;
`;

const ErrorFallback = () => {
  return /*#__PURE__*/React.createElement(ErrorWrapper, null, /*#__PURE__*/React.createElement("img", {
    src: errorBoundary,
    alt: "",
    width: 300
  }), /*#__PURE__*/React.createElement(Title, {
    heading: 3
  }, "\u51FA\u9519\u4E86"), /*#__PURE__*/React.createElement(_Button, {
    type: "primary",
    onClick: () => window.location.assign(window.location.origin)
  }, "\u5237\u65B0"));
};

export const ErrorBoundaryProvider = ({
  children
}) => {
  return /*#__PURE__*/React.createElement(ErrorBoundary, {
    FallbackComponent: ErrorFallback
  }, children);
};